export default __webpack_public_path__ + "static/media/process-bg.87b128cc.png";